import { useRole } from 'domain/hooks/useAuth';
import { Link } from 'react-router-dom';

/**
 * RoleGuard component
 * This component prevents the rendering of
 * a component if the user does not have the
 * required role.
 */
export const RoleGuard = ({
	children,
	role,
}: React.PropsWithChildren<{ role: string }>) => {
	const currentRole = useRole();

	if (currentRole.includes(role as any)) {
		return <>{children}</>;
	}

	return null;
};

/**
 * LinkGuard component
 * This component prevents the rendering of
 * a link if the user does not have the
 * required role.
 */
export const LinkGuard = ({
	children,
	to,
	role,
	hidden,
}: React.PropsWithChildren<{ role: string; to: string; hidden?: boolean }>) => {
	const currentRole = useRole();

	if (currentRole.includes(role as any)) {
		return (
			<Link to={to} className='cursor-pointer hover:shadow-lg'>
				{children}
			</Link>
		);
	}

	if (hidden) {
		return null;
	}

	return <>{children}</>;
};
